module.exports = __webpack_public_path__ + "img/سربرگ-افقی.ea21849a.png";